import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: 1,
};

export const creditTag: SxStyle = {
  display: 'flex',
  alignItems: 'center',
};

export const loadingIcon: SxStyle = {
  color: (p) => p.palette.common.white,
};
